export const draftQuotesTableCells = [
  {
    label: 'Quote Name',
    sortField: 'quote_name',
    display: true,
    width: 80,
  },
  {
    label: 'Quote Type',
    sortField: 'quote_type',
    display: false,
    width: 80,
  },
  {
    label: 'Created By',
    sortField: 'created_by',
    display: true,
    width: 80,
  },
  {
    label: 'Date Created',
    sortField: 'date_created',
    display: false,
    width: 100,
  },
  {
    label: 'Quote Discount',
    sortField: 'quote_discount',
    display: true,
    width: 100,
  },
  {
    label: 'Total',
    sortField: 'total',
    display: true,
    width: 80,
  },
  {
    label: 'Status',
    sortField: 'status',
    display: false,
    width: 80,
  },
];

export const recentQuotesTableCells = [
  {
    label: 'Quote ID',
    sortField: 'quote_id',
    display: true,
    width: 100,
  },
  {
    label: 'Customer Name',
    sortField: 'customer_name',
    display: false,
    width: 100,
  },
  {
    label: 'Customer Email',
    sortField: 'customer_email',
    display: false,
    width: 100,
  },
  {
    label: 'Created By',
    sortField: 'created_by',
    display: true,
    width: 160,
  },
  {
    label: 'Date Created',
    sortField: 'date_created',
    display: false,
    width: 100,
  },
  {
    label: 'Date Start',
    sortField: 'start_date',
    display: false,
    width: 100,
  },
  {
    label: 'Date Expire',
    sortField: 'expired_date',
    display: false,
    width: 100,
  },
  {
    label: 'Quote Discount',
    sortField: 'quote_discount',
    display: true,
    width: 100,
  },
  {
    label: 'Total',
    sortField: 'total',
    display: true,
    width: 80,
  },
  {
    label: 'Status',
    sortField: 'status',
    display: true,
    width: 80,
  },
];
